import StencilHTMLElement from "./stencil-element";

class ScrollToTop extends StencilHTMLElement {
  name = "ScrollToTop";

  button;
  scrollThreshold = 300;
  ticking = false;

  constructor() {
    super();
  }

  connectedCallback() {
    // Get the button element (should be a child of this custom element)
    this.button = this.querySelector('button');
    
    if (!this.button) {
      console.warn(this.logPrefix, 'Scroll to top button not found');
      return;
    }

    // Get scroll threshold from data attribute if provided
    if (this.dataset.threshold) {
      this.scrollThreshold = parseInt(this.dataset.threshold, 10);
    }

    // Attach click handler for smooth scroll
    this.button.addEventListener('click', this.handleClick.bind(this));

    // Initial check on page load
    this.handleScroll();

    // Listen for scroll events with throttling for better performance
    window.addEventListener('scroll', this.handleScrollEvent.bind(this), { passive: true });
  }

  disconnectedCallback() {
    // Clean up event listeners when element is removed
    window.removeEventListener('scroll', this.handleScrollEvent.bind(this));
  }

  handleScrollEvent() {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.handleScroll();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  handleScroll() {
    if (!this.button) return;

    if (window.scrollY > this.scrollThreshold) {
      this.button.classList.add('is-visible');
    } else {
      this.button.classList.remove('is-visible');
    }
  }

  handleClick(e) {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}

export default ScrollToTop;

